<script>
export default {
  name: "button-menu-campaign",
  methods: {
    removeCampaignItems() {
      this.$emit("removeCampaignItems");
    },
    show_other_campaign() {
      this.$emit("showOtherCampaign");
    },
    showLpm() {
      this.$emit("showLpm");
    }
  }
};
</script>

<template>
  <div> 
    <b-tooltip placement="right" target="tooltip-email" variant="dark">
      Generate (nearly) free money by sending your customers the right emails at
      the right time, automatically
    </b-tooltip>
    <b-tooltip placement="right" target="tooltip-sendgrid" variant="dark">
      Generate (nearly) free money by sending your customers the right emails at
      the right time, automatically using SendGrid
    </b-tooltip>
    
    <b-tooltip placement="right" target="tooltip-facebook" variant="dark">
      Increase ROI up to 14x over traditional look-alike audiences by targeting
      high propensity audiences based upon their spending patterns
    </b-tooltip>
    <b-tooltip placement="right" target="tooltip-google" variant="dark">
      Increase ROI up to 14x over traditional look-alike audiences by targeting
      high propensity audiences based upon their spending patterns
    </b-tooltip>
    <b-tooltip placement="right" target="tooltip-lpm" variant="dark">
      Only pay when we prove a customer who saw the campaign spent money at your
      business
    </b-tooltip>
    <b-tooltip placement="right" target="tooltip-other-campaign" variant="dark">
      If you ran any other type of campaign set it up here so we can measure the
      ROI
    </b-tooltip>
    <div class="d-flex">
      <b-button-toolbar>
        <b-dropdown class="mx-1" squared text="Create Campaign">
          <b-dropdown-item v-b-modal.modal-add-campaign id="tooltip-email">
            Email
          </b-dropdown-item>
          <b-dropdown-item v-b-modal.modal-add-sendgrid-campaign id="tooltip-sendgrid">
            Email with Sendgrid
          </b-dropdown-item>
          
          <b-dropdown-item disabled id="tooltip-facebook">
            Facebook
          </b-dropdown-item>
          <b-dropdown-item disabled id="tooltip-google">
            Google
          </b-dropdown-item>
          <b-dropdown-item
            id="tooltip-lpm"
            @click="showLpm"
            v-b-modal.local-performance-marketing-modal
          >
            Local Performance Marketing (LPM)
          </b-dropdown-item>
          <b-dropdown-item
            @click="show_other_campaign"
            id="tooltip-other-campaign"
          >
            Other Campaign
          </b-dropdown-item>
        </b-dropdown>
      </b-button-toolbar>
      <b-button type="button" @click="removeCampaignItems">
        Remove
      </b-button>
    </div>
  </div>
</template>
